import React from 'react'
import { Container } from 'react-bootstrap'
import styled from 'styled-components'

const Agreement = () => {
  return (
    <>
      <Container>
        <div className="content aria" style={{ padding: "20px", lineHeight: "1.6" }}>
          <h3 className="text-center">이용약관</h3>
          <Line></Line>
          <div>
            HEXACEPS㈜(이하 회사)는 ｢개인정보 보호법｣ 에 따라 이용자의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립 및 공개합니다.
            <br /><br />
            제1조 (개인정보의 처리목적)
            <br />
            회사는 다음의 목적을 위하여 개인정보를 처리하며, 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않습니다. 이용 목적이 변경되는 경우에는 ｢개인정보 보호법｣ 에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
            또한 회사는 만 14세 이상의 이용자를 대상으로 서비스를 제공하며, 만 14세 미만 아동의 개인정보가 수집된 사실을 인지하는 경우 해당 정보를 지체없이 삭제하겠습니다.
            <br /><br />
            1. 회원 가입 및 관리<br />
            회원 가입의사 확인과 회원제 서비스 제공에 따른 회원자격 유지 및 관리, 서비스 부정이용 방지, 각종 고지와 통지, 고충처리 목적으로 개인정보를 처리합니다.
            <br /><br />
            2. 서비스 제공<br />
            서비스 및 콘텐츠, 광고를 포함한 맞춤형 서비스 제공을 목적으로 개인정보를 처리합니다.
            <br /><br />
            3. 고충처리<br />
            이용자의 신원 확인, 문의사항 확인, 사실조사를 위한 연락, 통지, 처리결과 통보의 목적으로 개인정보를 처리합니다.
            <br /><br />
            4. 이벤트 참여<br />
            이벤트 참여 기회 제공, 경품 제공, 제세공과금 처리를 위해 개인정보를 처리합니다. 
            <br /><br />
            제2조 (개인정보의 처리 및 보유기간)
            <br />
            ① 회사는 법령에 명시되어 있거나 이용자로부터 개인정보 수집 시 동의 받은 개인정보의 보유 및 이용기간 내에서 개인정보를 처리 및 보유합니다.
            <br />
            ② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.
            <br /><br />
            1. 회원 가입 및 관리: 회원 탈퇴 시까지<br />
            다만, 다음의 사유에 해당하는 경우에는 해당 사유 종료 시까지<br /><br />
            1) 관계 법령 위반에 따른 수사, 조사 등이 진행 중인 경우에는 해당 수사, 조사 종료 시까지<br />
            2) 서비스 이용에 따른 채권, 채무관계 잔존 시에는 해당 채권, 채무관계 정산 시까지<br />
            <br />
            2. 서비스 제공: 서비스 공급 완료 또는 서비스 이용 종료 시까지<br />
            다만, 다음의 사유에 해당하는 경우에는 내부 기준에 따른  보관기간 종료 시까지<br /><br />
            1) 부정이용 방지를 위한 정보(CI, 거래내역, 부정이용 내역, 주소, 기기 정보): 회원 탈퇴일로부터 3년<br />
            2) 이벤트 진행 및 경품 배송, 제세공과금 처리를 위한 정보(이름, 주소, 휴대전화번호, 신분증): 3개월<br />
            3) 거래처 등록 및 대금 지급을 위한 정보(거래처 등록서류, 입금계좌 정보): 정보 확인 및 거래처 등록 후 3개월<br /><br />
            
            3. 고충처리: 고충 처리 완료 시까지<br />
            다만, 다음의 사유에 해당하는 경우에는 해당 기간 종료 시까지<br />
            <br />
            <br />
          </div>
        </div>
      </Container>
    </>
  )
}

const Line = styled.div`
 height: 4px; /* 선 두께 */
  background-color: black; /* 선 색상 */
  width: 100%; /* 선 길이 */
  margin: 25px 0; /* 위아래 여백 */
  `

export default Agreement